export default "__VITE_ASSET__AinTskDM__"